import { Button, notification, Spin } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import streamSaver from 'streamsaver'
import { triggerErrorNotification } from '../../../core/utils/notificationUtils';
import app from '../../../core/constants';
import Spinner from '../../Spinner';
const { STREAMING_SAVER_MITM } = app;
streamSaver.WritableStream = streamSaver.WritableStream
streamSaver.mitm = STREAMING_SAVER_MITM;

function ExportVideoStatus({
    exportedCacheVideo, checkStatus, requestExportCacheVideo, isShareView, channels, pendingVideoes
}) {
    const timeoutIdRef = useRef(null);
    const interval = 3000;
    const processingStatus = ['requested', 'processing'];
    let initalWatcherState = false;
    if (isShareView !== true) {
        initalWatcherState = !!(processingStatus.includes(exportedCacheVideo?.status));
    }
    const [startWatcher, setWatcher] = useState(initalWatcherState);
    // responseType
    const downloadFile = (url, fileName) =>
        // return fetch(url).then(res => {
        fetch(url).then((res) => {
            if (res.status !== 200) {
                throw new Error(res.status);
            }
            const fileStream = streamSaver.createWriteStream(fileName);
            const writer = fileStream.getWriter();
            if (res.body.pipeTo) {
                writer.releaseLock();
                return res.body.pipeTo(fileStream);
            }

            const reader = res.body.getReader();
            const pump = () => reader
                .read()
                .then(({ value, done }) => (done ? writer.close() : writer.write(value).then(pump)));

            return pump();
        })
        .then(() => {
            notification.success({
                message: 'Success',
                description: 'The export has started. Please check your downloads folder.',
            });
        });
    const exportVideo = () => {
        const downloadURL = exportedCacheVideo.aws_url;
        const { pathname } = new URL(downloadURL);
        const fileName = pathname.substring(pathname.lastIndexOf('/') + 1);
        downloadFile(downloadURL, fileName).catch((errr) => {
            triggerErrorNotification('Failed to download file.');
            console.error(errr);
        });
    };

    useEffect(() => {
        let _stopped = false;
        const pollingCallback = async () => {
            try {
                const result = await checkStatus();
                _stopped = !processingStatus.includes(result?.status);
            } finally {
                // Set timeout after it finished, unless stopped
                timeoutIdRef.current = !_stopped && setTimeout(
                    pollingCallback,
                    interval,
                );
            }
        };
        if (startWatcher) {
            pollingCallback();
        }
        return () => {
            _stopped = true; // prevent racing conditions
            setWatcher(false);
            clearTimeout(timeoutIdRef.current);
        };
    }, [startWatcher]);
    let exportVideoOption = (
        <Button
            onClick={async () => {
                await requestExportCacheVideo();
                setWatcher(true);
            }}
            type="primary"
            disabled={(!channels || channels.length < 1 || pendingVideoes?.length >= 1) || exportedCacheVideo?.status === 'processing'}
        >
            {exportedCacheVideo?.status ? (
                <span style={{ marginRight: '8px' }}>
                    <Spinner size={22} minHeight={22} loading={exportedCacheVideo?.status === 'processing'} ></Spinner>
                </span>
            ) : null}
            Export
        </Button>
    );

    if (exportedCacheVideo?.status === 'processed') {
        exportVideoOption = (
            <Button
                type="primary"
                onClick={exportVideo}
                className="btn"
                disabled={(!channels || channels.length < 1 || pendingVideoes?.length >= 1)}
            >
                Export
            </Button>
        );

    } else if (exportedCacheVideo?.status === 'errored') {
        exportVideoOption = (
            <span>
                Failed to export video
            </span>
        );
    }

    if (isShareView && exportedCacheVideo?.status !== 'processed') {
        exportVideoOption = null;
    }

    return (<div className="exporting-video">{exportVideoOption}</div>);
}
export default ExportVideoStatus;
